export default "__VITE_ASSET__39fced0e__"